export var FIELD_UPDATE_STATUS;
(function (FIELD_UPDATE_STATUS) {
    FIELD_UPDATE_STATUS["NONE"] = "NONE";
    FIELD_UPDATE_STATUS["LOADING"] = "LOADING";
    FIELD_UPDATE_STATUS["UPDATE_SUCCESSFUL"] = "UPDATE_SUCCESSFUL";
    FIELD_UPDATE_STATUS["UPDATE_FAILURE"] = "UPDATE_FAILURE";
})(FIELD_UPDATE_STATUS || (FIELD_UPDATE_STATUS = {}));
export var BRAND;
(function (BRAND) {
    BRAND[BRAND["SUB_BRAND"] = 1] = "SUB_BRAND";
    BRAND[BRAND["CHANNEL"] = 2] = "CHANNEL";
    BRAND[BRAND["COBRAND"] = 3] = "COBRAND";
    BRAND[BRAND["YODLEE"] = 4] = "YODLEE";
})(BRAND || (BRAND = {}));
//# sourceMappingURL=commons.js.map